import { safeGetJSON } from './storage';
import type { JourneyMemory } from '../types/onboarding';

const JOURNEY_MEMORY_KEY = 'journey_memory';

export function getJourneyMemory(): JourneyMemory | null {
  return safeGetJSON<JourneyMemory | null>(JOURNEY_MEMORY_KEY, null);
}
